module.exports = __webpack_public_path__ + "images/help/icn-faq-problem-4d2e8c0ba7c18c7bc82784b59eec83e1.png";